/**
 * reduce event occurs
 */
export function throttle (callbackFn, limit) {
  let wait = false;
  return function () {
    if (!wait) {
      callbackFn.call();
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  }
}

export function stopEvent(e) {
  e.stopPropagation?.();
  e.preventDefault?.();
}
export function stopProp(e) {
  e.stopPropagation?.();
}

export function pressEnter(event, callback = () => {}) {
  if (event.key === "Enter") {
    stopEvent(event);
    callback();
  }
}

